import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '@/views/Home.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/record',
    name: 'record',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this routeH
    // which is lazy-loaded when the route is visited.
    component: () => import('@/views/Record.vue')
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/Login.vue')
  },
]

const router = new VueRouter({
  routes
})


// 路由守卫：判断cookie中有无phone和token
router.beforeEach((to, from, next) => {
  // 只对非登录页做校验
  if (to.path !== '/login') {
    // 获取cookie
    function getCookie(name) {
      const matches = document.cookie.match(new RegExp(
        '(?:^|; )' + name.replace(/([.$?*|{}()\[\]\\\/\+^])/g, '\\$1') + '=([^;]*)'
      ));
      return matches ? decodeURIComponent(matches[1]) : undefined;
    }
    const phone = getCookie('phone');
    const token = getCookie('token');
    if (!phone && !token) {
      next('/login');
      return;
    }
  }
  next();
});

export default router
